import {
  Card,
  CardBody,
  CardImg,
  CardGroup,
  CardTitle,
  CardSubtitle,
  CardText,
} from "reactstrap";
import { FaGithub } from "react-icons/fa";
import { VscGlobe } from "react-icons/vsc";
import ecom1 from "../image/ecom1.png";
import ecom3 from "../image/ecom3.png";
import restra from "../image/RK-Restra.png";
import NMT from "../image/NMT.png";

export default function Projects() {
  return (
    <section id="prodects">
      <div className="container">
        <h2 className=" bg-dark text-center text-uppercase text-secondary ">
          My Projects
        </h2>
        <div className="row">
          <CardGroup>
            <Card>
              <CardImg top width="100%" src={restra} alt="Card image cap" />
              <CardBody>
                <CardTitle tag="h5">Food Delivery(RK-RESTRA)</CardTitle>
                <CardSubtitle tag="h6" className="mb-2 text-muted">
                  ReactJS, Bootstrap,, Redux
                </CardSubtitle>
                <CardText>
                  Food Delivery app using react, bootstrap and redux
                </CardText>
                <a href="https://rk-restra.netlify.app/" target="_blank">
                  <VscGlobe size="30px" color="black" />
                </a>
              </CardBody>
            </Card>
            <Card>
              <CardImg top width="100%" src={ecom3} alt="Card image cap" />
              <CardBody>
                <CardTitle tag="h5">E-Learning Website</CardTitle>
                <CardSubtitle tag="h6" className="mb-2 text-muted">
                  ReactJs Gatsby Contentful Github Netlify
                </CardSubtitle>
                <CardText>
                  Built with gatsby and reactjs and deploy on netlify with the
                  help of github.
                </CardText>
                <a href="https://ravi-ecom.netlify.app/" target="_blank">
                  <VscGlobe size="30px" color="black" />
                </a>
              </CardBody>
            </Card>
            <Card>
              <CardImg top width="100%" src={ecom1} alt="Card image cap" />
              <CardBody>
                <CardTitle tag="h5">E-Commerce Website</CardTitle>
                <CardSubtitle tag="h6" className="mb-2 text-muted">
                  HTML CSS BOOTSTRAP MYSQL PHP
                </CardSubtitle>
                <CardText>
                  Created a ecommerce website with including SignUp, SignIn,
                  SignOut, Change Password and Add To Cart features.
                </CardText>

                <a
                  href="https://github.com/ravi13jun31997-bot/E-commerce"
                  target="_blank"
                >
                  <FaGithub size="30px" color="black" />
                </a>
              </CardBody>
            </Card>
            <Card>
              <CardImg top width="100%" src={NMT} alt="Card image cap" />
              <CardBody>
                <CardTitle tag="h5">Network Monitoring Tool</CardTitle>
                <CardSubtitle tag="h6" className="mb-2 text-muted">
                  LAMP-LINUX APACHE MYSQL PHP
                </CardSubtitle>
                <CardText>
                  This is a web based application to analayze the network
                  traffic.
                </CardText>
                <a
                  href="https://github.com/ravi13jun31997-bot/NMT"
                  target="_blank"
                >
                  <FaGithub size="30px" color="black" />
                </a>
              </CardBody>
            </Card>
          </CardGroup>
        </div>
      </div>
    </section>
  );
}
